export interface TouchButtonHandlers {
  onSprayDown(): void;
  onSprayUp(): void;
  onJump(): void;
}

/** On-screen Spray (hold) and Jump buttons for touch devices. */
export class TouchButtons {
  readonly root: HTMLDivElement;

  constructor(parent: HTMLElement, handlers: TouchButtonHandlers) {
    this.root = document.createElement('div');
    this.root.id = 'touch-buttons';
    this.root.innerHTML = `
      <button id="tb-jump" class="tb-btn" aria-label="Jump">⤒<span>jump</span></button>
      <button id="tb-spray" class="tb-btn" aria-label="Hold to spray">●<span>spray</span></button>
    `;
    parent.appendChild(this.root);

    const spray = this.root.querySelector<HTMLButtonElement>('#tb-spray')!;
    const jump = this.root.querySelector<HTMLButtonElement>('#tb-jump')!;

    const press = (e: Event) => {
      e.preventDefault();
      spray.classList.add('active');
      handlers.onSprayDown();
    };
    const release = (e: Event) => {
      e.preventDefault();
      spray.classList.remove('active');
      handlers.onSprayUp();
    };
    spray.addEventListener('touchstart', press, { passive: false });
    spray.addEventListener('touchend', release, { passive: false });
    spray.addEventListener('touchcancel', release, { passive: false });

    jump.addEventListener(
      'touchstart',
      (e) => {
        e.preventDefault();
        handlers.onJump();
      },
      { passive: false },
    );
  }

  setVisible(visible: boolean): void {
    this.root.classList.toggle('hidden', !visible);
  }
}
